const mapSizes = {
  xs: {
    padding: "0 12px",
    height: "24px",
    width: "24px"
  },
  sm: {
    padding: "0 12px",
    height: "32px",
    width: "32px"
  },
  md: {
    padding: "0 18px",
    height: "42px",
    width: "42px"
  },
  lg: {
    padding: "0 18px",
    height: "62px",
    width: "62px"
  }
}, mapFontVariants = {
  xs: "12_18_600",
  sm: "14_18_600",
  md: "14_18_600",
  lg: "16_20_600"
}, mapIconContainerSizes = {
  xs: "18px",
  sm: "18px",
  md: "24px",
  lg: "24px"
};
export {
  mapFontVariants,
  mapIconContainerSizes,
  mapSizes
};
//# sourceMappingURL=constants.js.map
